export default {
	Title: 'Report',
	AllReport: 'All reports',
	GroupInvoiceList: 'Input Invoice List',
	GroupInvoiceListThirdParty: 'Invoice list',
	GroupRiskControl: 'Input Risk Control',
	GroupRiskControlThirdParty: 'Risk control',
	GroupCostManagement: 'Input Cost Management',
	GroupCostManagementThirdParty: 'Cost management',
	ReportList: {
		SearchPlaceHolder: 'Enter invoice no., supplier, seller tax code, buyer tax code, note to search',
		SearchPlaceHolderRest: 'Enter invoice no., supplier, seller tax code, buyer tax code...',
		SearchPlaceHolderReportInvoiceRelated: 'Enter invoice no., supplier, taxcode to search.',
		SearchPlaceHolderReportInvoiceStick: 'Enter sticker name to search.',
		ReportInvoiceStick: 'Report on cost statistics by label',
		ReportName: 'Report name',
		ReportInvoiceRiskBySupplier: 'Report invoice risk to supplier',
		ReportInvoiceSupplierActive: 'Report invoices according to supplier performance status',
		ReportInvoiceRelated: 'Report invoices adjusted, replacement',
		ReportExceedFiveMillion: 'Report of suppliers with total invoices value exceeding five million per day',
		ReportInvoiceGeneralPurchase: isCheckThirdParty =>
			isCheckThirdParty
				? 'Invoice list for goods and services (summary)'
				: 'Invoice list for goods and services purchased (summary)',
		ReportInvoiceDetailPurchase: isCheckThirdParty =>
			isCheckThirdParty
				? 'Invoice list for goods and services (detail)'
				: 'Invoice list for goods and services purchased (detail)',
		SupplierActiveTitle: 'Report invoices according to supplier performance status',
		SupplierActiveTab1: 'At the current date',
		SupplierActiveTab2: 'At the date of invoice',
		FilterReport: 'Filter report',
		ReportCostSummary: 'Report cost summary',
		ReportExceedCost: 'Report of invoices exceeding the limit',
		ReportTypeAndCost: 'Report cost type and limit'
	},
	SelectDateRangeReport: 'You have not selected the reporting period yet',
	LastUpdateInfo: 'Report instructions ',
	InvoiceProcessStatus: 'Invoice processing status',
	InvoiceStatus: 'Invoice status',
	StickOne: 'Sticker 1',
	StickTwo: 'Sticker 2',
	StickThree: 'Sticker 3',
	SeemInvoiceAdjust: 'View invoice adjustment',
	SeemInvoiceReplacement: 'View replacement, adjustment invoice',
	NotPermissonInvoice: 'No permission to view invoice',
	DescriptionNotPremissonInvoice:
		'The invoice belongs to the unit that you do not have the right to work. Please contact the user with the Administrator role for permission.',
	Instruction: {
		InstructionTitle: 'Instructions for viewing the Invoice List',
		InstructionContent: {
			Text: (isGeneral, isCheckThirdParty) =>
				`Program records you want to view the Invoice list for goods and services ${isCheckThirdParty ? '' : 'purchased'
				} ${isGeneral ? '(summary)' : '(detail)'}, please perform the following steps:`,
			Step1: 'Switch to ',
			AftefStep1: isCheckThirdParty => (isCheckThirdParty ? 'Invoice' : 'Invoice input'),
			Step2: isCheckThirdParty =>
				isCheckThirdParty ? 'At the invoice screen, select ' : 'At the invoice input screen, select ',
			AftefStep2: 'filter conditions ',
			AftefStep2_1: '(if necessary) and press the ',
			AftefStep2_2: 'Export',
			Step3: 'At the export screen, select ',
			AftefStep3: 'invoice list ',
			AftefStep3_1: 'and press the',
			AfterStep3_2: 'Export ',
			AfterStep3_3: 'to download'
		},
		SwitchToInvoiceList: isCheckThirdParty => (isCheckThirdParty ? 'Switch to Invoice ' : 'Switch to Invoice input')
	},
	InvoiceListStick: {
		Title: 'List of invoices',
		InvoiceNo: 'Invoice No.',
		InvoiceDate: 'Invoice date',
		TemplateNo: 'Form No.',
		Series: 'Series',
		Supplier: 'Supplier',
		TotalAmount: 'Total amount',
		BuyerName: 'Buyer name',
		ResultChecker: 'Checking result',
		InvoiceStatus: 'Invoice status',
		SellerTaxCode: 'Tax Code',
		TotalAmountVAT: 'Total VAT amount',
		TotalAmountExchange: 'Total amount exchange',
		InvoiceTotalHasDiscount: 'Untaxed revenue',
		ViewInvoiceList: 'View invoice list'
	},
	GuideLine: 'The data may not be accurate in some special cases.',
	GuideLineLink: 'View instructions',
	AmountExceedCost: 'Amount exceeding the limit',
	ExceedCostRate: 'Exceeding the limit rate',
	ShowUnclassifiedCost: 'Show unclassified costs',
	ShowUnclassifiedCostTooltip: 'Display additional data for invoices that have not been cost classified',
	UnclassifiedCost: 'Unclassified costs',
	MsgBoxContent: `<div style="font-size: 16px; margin-bottom: 8px; font-weight: 700;text-align: center;">The analysis process is in progress</div><span>AVA is analyzing data on the software and will return the results in the <span class="font-bold">Bell notification</span> after a few minutes.</span>`,
	NoDataCosttypeMonth:
		'The function can only be performed when there is at least one cost type with incurred data and the total cost in the period is not equal to 0. View cost classification instructions <span style="color: #00A2CF; cursor: pointer" @click="abc">here</span>.',
	NoAnalysisData:
		'Currently, the program only supports fluctuation analysis when the report time parameter is <span class="font-bold">Quarter</span> and the cost type is <span class="font-bold">All.</span>',
	AnalysisReport: 'Analysis of expense data fluctuations',
	AnalysisInProgress: 'Data analysis in progress, please wait...',
	ComparisonPeriod: 'Comparison period',
	CompareType: 'Comparison type',
	ViewLastestHistory: 'View latest analysis results',
	NoHistoryAnalysis: 'No recent analysis results available',
	AnalysisReportProcessingAlert: 'The system is analyzing. Please wait a moment.',
	InvoicesPerDay: 'List of daily invoices from suppliers',
	OnlyCash: 'Show only Cash payment method',
	OnlyAmountFromFiveMillion: 'Show only invoices from 5 million',
	NoData: 'The report has no data.',
	Filter: 'Filter',
	ApplyFilter: 'Apply',
	InvoiceDateShort: 'Invoice date',
	FilterHover: 'Filter'
};
